// extracted by mini-css-extract-plugin
export default {"main":"select_main__lFQIF","value":"select_value__0PRCc","list":"select_list__da7ph","open":"select_open__ZHyYS","option":"select_option__6dQTI","selected":"select_selected__WkH6b"};